export const getStartYear = (effectiveDate: Date, terminationDate: Date): number => {
  let actualYear = new Date().getFullYear();
  let endYear = new Date(terminationDate).getFullYear();
  let effectiveYear = new Date(effectiveDate).getFullYear();

  if (actualYear < effectiveYear) {
    return effectiveYear;
  }
  else if (endYear > actualYear) {
    return actualYear;
  } else {
    return endYear;
  }
}

/**
 * Checks whether a selected year lies within the contract duration defined by effective and termination dates.
 */
export const isYearWithinContract = (
  selectedYear: number,
  effectiveDate?: Date | string | null,
  terminationDate?: Date | string | null
): boolean => {
  if (!effectiveDate) return false;

  const eff = new Date(effectiveDate);
  if (isNaN(eff.getTime())) return false;
  const effYear = eff.getFullYear();

  if (!terminationDate) {
    return selectedYear >= effYear;
  }

  const term = new Date(terminationDate);
  if (isNaN(term.getTime())) {
    return selectedYear >= effYear;
  }

  const termYear = term.getFullYear();
  return selectedYear >= effYear && selectedYear <= termYear;
};